// module.exports = [
  // {
  //   path: '/login.html',
  //   meta: {
  //     title: 'login',
  //     author: 'gejianfang'
  //   },
  //   component: resolve => resolve(require('@/page/main_content/main.vue'))
  // },
//    {
//     path: '/index.html',
//     meta: {
//       title: '智慧燃气安全管控平台',
//       author: 'gejianfang'
//     },
//     component: resolve => resolve(require('@/page/main_content/main.vue'))
//   },{
//     path: '/login.html',
//     meta: {
//       title: '系统登录页',
//       author: 'gejianfang'
//     },
//     component: resolve => resolve(require('@/page/login/login.vue'))
//   }
// ]


import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

import main_content from './main_content'
import login from './login'
Vue.use(Router);

export default new Router({
  routes: [
    login,
    main_content
  ]
});


// WEBPACK FOOTER //
// ./src/router/index.js